<div class="bmc-deployment-bex-container">
    <biz-upload-bex [status]="status" [statusApply]="statusApply" [showLoading]="isLoading" [isProcessing]="isProcessing"
        (onCancelImport)="cancelImport()" [currentBex]="($currentBex | async)" (onUploadPackage)="uploadPackage($event)"
        (onImportPackage)="importPackage()" (onShowMaintenanceWindow)="showMaintenanceWindow()">
    </biz-upload-bex>
    <biz-previous-processes-table [history]="($history | async)" [isLoading]="($isLoadingHistory | async)" [isProcessing]="isProcessing"
        (onDownloadFile)="downloadFile($event)" (onViewSummary)="openPackageVisualizer($event)">
    </biz-previous-processes-table>
</div>
